<template>
    <div>
      <top-navbar></top-navbar>
      <div class="mb-5 background_color">
        <!-- Breadcrumbs and Header -->
        <h6 class="manage-boder pt-2 font1  decoration"> 
          <router-link class="decoration" to="/"> {{language[1]['Home']}} </router-link>
         
          <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
          <router-link class="decoration" to="/usertype/index"> {{language[104]['Manage User Type']}}  </router-link>
          <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
          {{ roles.name }}
        </h6>
    
        <div class="container-fluid">
          <!-- Navbar with controls -->
          <div class="navbar background_color" style="border: 0px; padding: 0px; min-height:0px">
            <div class="d-flex">
              <b-input-group size="sm" style="width: 225px;">
                <b-form-input 
                  id="filter-input" 
                  v-model="filter" 
                  @input="loadMiinventory()" 
                  type="search" 
                  placeholder="Search"
                ></b-form-input>
              </b-input-group>
  
              <div class="ms-2" style="position: relative;">
                <v-select 
                  @input="loadMiinventory()" 
                  class="font-size_def small-select" 
                  label="label" 
                  v-model="checkitm"   
                  :options="checkitmselect" 
                  style="width: 225px;"
                ></v-select>
              </div>
  
              <div style="margin-top: 11px;" class="ms-2">
                <span class="custom-breadcrumb">
                  <b>{{language[11]['Showing ']}} {{ currentPage }}-{{ currentPage * perPage }} {{language[12]['of ']}}  {{ totalRows }} {{language[13]['items']}}.</b>
                </span>
              </div>
            </div>
  
            <div class="d-grid d-md-flex justify-content-md-end">
              <button @click="urlCreate()" class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad"> {{language[52]['Create']}}</button>
              <button @click="SaveCreate()" class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">{{language[81]['Save']}}</button>
            </div>
          </div>
  
          <!-- <div class="navbar" style="border: 0px; padding: 0px; min-height:0px">
            <div class="d-flex">
              </div>
              <div class="d-grid d-md-flex justify-content-md-end">
            <label class="" for="selectAll">Select All</label>
            <input 
              type="checkbox" 
              id="selectAll" 
              class="ms-4 mb-2"
              v-model="selectAllChecked" 
              @change="toggleAll"
            > 
           
          </div>
          </div> -->
          <!-- Master Checkbox -->
         
  
          <!-- Data Table -->
          <div class="card bdr-rad2 mt-1 shadow p-2 ">
            <div class="card-body ">
              <div class="d-flex justify-content-center" v-if="isLoading">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div v-else>
                <div class="table-responsive">
                  <b-table  
                    responsive
                    style="font-size: small;"
                    class="table-hover"
                    :items="all_datas"
                    :fields="fields"
                    :current-page="currentPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    show-empty
                    small
                  >
                    <template #cell(actions)="row">
                      <!-- <input style="margin-left: 0px;"
                        class="form-check-input " 
                        type="checkbox" 
                        v-model="row.item.per"
                      > -->
  
                      <div class="form-check form-switch">
                        <input v-model="row.item.per" class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                      
                      </div>
                  
                    </template>
  
                    <template #cell(update)="row">
                      <!-- <input style="margin-left: 0px;"
                        class="form-check-input " 
                        type="checkbox" 
                        v-model="row.item.per"
                      > -->
                      <button  style=" font-size: small;"
                        @click="Update(row.item.id)" class="mr-1 btn  btn-outline-primary btn-sm mb-1">
                        {{language[78]['Update']}}
                      </button>
                   
                    </template>
                    <template #head(actions)="data">
                      
                        
                        <div class="row ">
                      
                          <div style="margin-left: 10px;" class="col-md-1 ">
                            <div class="form-check form-switch ">
                            <input  v-model="selectAllChecked"  @change="toggleAll"  class="form-check-input" type="checkbox"  id="selectAll" >
                            </div>
                          </div>
                          <div style="margin-left: -10px;" class="col-md-4">
                             {{language[24]['Actions']}}
                          </div>
                          
                       
  
  
  
                        </div>
                       
                        
                    </template>
  
                    <template #cell(number)="row">
                      {{ row.index + 1 === 10 ? currentPage * 10 : (currentPage - 1) * 10 + row.index + 1 }} 
                    </template>
                  </b-table>
                </div>
              </div>
  
              <div style="border: 0px; padding: 0px; min-height:0px" class="navbar">
              <div class="d-flex">
               
              
    
              
              </div>
    
              <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button @click="SaveCreate()" class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">{{language[81]['Save']}}</button>
               
              </div>
            </div>
            </div>
          </div>
          <br><br>
        </div>
      </div>
      <content-footer></content-footer>
    </div>
  </template>
    
      
      <script>
     
     import axios from 'axios';
     import vSelect from 'vue-select';
     import authService from '@/auth.service';
     import TopNavbar from './../../layout/TopNavbar.vue';
     import ContentFooter from './../../layout/ContentFooter.vue'
    import DatePicker from 'vue2-datepicker';
     import 'vue2-datepicker/index.css';
      
      
      
      export default {
    watch: {
    },
        components :{
          'v-select': vSelect,
            TopNavbar,
            ContentFooter,
            DatePicker,
            
        },
  
        created(){
          this.loadMiinventory()
        },
      
          mounted(){
            this.fields= [
            { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
            { key: 'page_name', label: this.language[65]['Page Name'], sortable: true,  },
            { key: 'name', label: this.language[66]['Permissions'], sortable: true,  },
          //   { key: 'PC_description', label: 'Product Category', sortable: true  },
          //   { key: 'P_code1', label: 'Product Code', sortable: true  },
          //   { key: 'P_description', label: 'Product Description', sortable: true  },
          //   { key: 'P_internal_selling_price', label: 'Selling Price (Rs)', sortable: true  },
          //   { key: 'status', label: 'Status', sortable: true  },
          //   { key: 'P_created_date', label: 'Created Date', sortable: true ,  },
          { key: 'actions', label: this.language[24]['Actions'], class:'width-custom2', },
          // { key: 'update', label: 'Permissions', sortable: true,  },
          
          ];
          },
         
          computed: {
            
      
      
      
          },
      
          data() {
        return {
          currentPage: 1,
          mcustomers:[],
          all_datas:[],
          roles:{},
          selectAllChecked: false, 
          id:this.$route.query.id,
        search: "",
        access_token:authService.isLoggedIn(),
          userid:authService.isUserid(),
          permissions:authService.isPermission(),
          language:JSON.parse(authService.isLanguage()),
          sortBy: '',
          sortDesc: false,
          sortDirection: 'asc',
          filter: null,
            FromDate: null,
            checkitm: null,
            ToDate: null,
          filterOn: [],
          totalRows: '',
          checkurl: [
              { label: 'Not', value: '0' },
              { label: 'View Only', value: '1' },
              { label: 'All', value: '2' },
          
              
          ],
          checkitmselect: [
              { label: 'ALL', value: '0' },
              { label: 'Show Only Selected', value: '1' },
              { label: 'Show Only Not Selected', value: '2' },
          
              
          ],
          
          perPage:15,
          pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
         
          fields:[],
         
            
          infoModal: {
            id: 'info-modal',
            title: '',
            content: {},
          },
          isLoading: true, 
      
         
        };
        },
      
    
     
    
      
          
      
      
         methods:{ 
  
          toggleAll() {
          this.all_datas.forEach(row => {
            row.per = this.selectAllChecked;
          });
        },
    
          async SaveCreate() {
    //  console.log(this.all_datas);
      try {
        const { data} = await  axios.post('/user/createpermission',{all_datas:this.all_datas,userid:this.id},{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         if(data.status=200){
          window.location.reload();
         }
        
        
        
      } catch (error) {
        console.log(error.response);
      }
    },
    
     
    
    
    
    
    
    
      
    
      async moreinfo(idproduct) {
    
    this.$router.push('/mproduct/view?id='+idproduct);
    
    },
    async urlCreate() {
    
    this.$router.push('/url/create');
    
    },
    async Update(id){
        this.$router.push('/url/update?id='+id);
      },
    
      serchCustom(id) {
    
    this.filterOn = id;
    },
        // onFiltered(filteredItems) {
        //     // Trigger pagination to update the number of buttons/pages due to filtering
        //     this.totalRows = filteredItems.length
        //     console.log(totalRows);
        //     this.currentPage = 1
        //   },
      
  async loadMiinventory(page = this.currentPage) {
            // const storedPermissions = this.permissions;
            // const permissionsArray = JSON.parse(storedPermissions);
            // console.log(permissionsArray);
         try {
            const { data} = await  axios.get('/user/permission2',{
    
              params: {
                page: page,
                id: this.id,
                perPage: this.perPage,
                filter: this.filter,
                FromDate: this.FromDate,
                checkitm: this.checkitm,
                ToDate: this.ToDate,
              },
              headers:{
                'Authorization':'Bearer '+this.access_token,
                'Content-type': 'application/json',
               
              }
             });
             console.log(data);
             this.all_datas = data.all_data;
            this.totalRows = data.total_count;
            this.currentPage = data.page;
            this.roles = data.roles;
           
            this.isLoading = false;
            
          } catch (error) {
            console.log(error.response);
          }
        },
    
        pageChanged(page) {
          console.log(page);
         this.loadMiinventory(page);
     },
    
    
        
         
      
       
      
      
      
      
      
      },
  
      watch: {
        all_datas: {
          handler(newVal) {
            this.selectAllChecked = newVal.every(row => row.item.per);
          },
          deep: true
        }
      }
      
      
      
      };
      
      </script>
      
      <style >
    
    
      .button1{
        width: 10px !important;
      }
      .border1{
        border: none;
        background-color: #0d6efd;
      }
      .font-color1:hover{
        color: black !important;
        cursor: pointer;
      }
      .manage-boder{
        border-bottom: 1px solid #E9E9E3;
        border-top: 1px solid #E9E9E3;
      }
      .border-radius0{
            border-radius:0px !important ;
      }
      .font1{
            font-size: 13px !important;
         
          }
          .font-bold1{
            font-weight: bold;
          }
          .manage-boder{
          border-bottom: 2px solid #E9E9E3;
          border-top: 2px solid #E9E9E3;
          padding-bottom: 10px !important;
          padding-top: 10px !important;
          
          }
          .font1{
            font-size: 13px !important;
         
          }
          .font-bold1{
            font-weight: bold !important;
          }
          .colr1{
              color:#A5A5A3;
              
          }
          .decoration{
          text-decoration: none;
          color:#A5A5A3  ;
        }
        .width7{
          width: 250px;
        }
        .bg-mycoolor{
          background-color: #a4d2f3 !important;
    
        }
       
      .modal-footer{
        text-align: right !important;
        display: block;
      }
    
      .pfimg3 {
      padding-left: 10px;
    }
    .decoration {
      text-decoration: none;
    }
    .width-custom3 {
      width: 180px;
    }
    .date-placeholder {
      position: absolute;
      top: 5px;
      left: 12px;
      pointer-events: none;
      color: #6c757d;
    }
    .small-select {
    font-size: 12px; /* Adjust font size */
    height: 34px; /* Adjust the height */
  }
  
  .small-select .vs__dropdown-toggle {
    padding: 0 10px; /* Adjust padding inside the select box */
    height: 32px; /* Ensure the height matches the overall select box */
  }
  
  .small-select .vs__dropdown-menu {
    font-size: 12px; /* Adjust dropdown font size */
  }
      
      </style>